import { type FC } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../shared/auth/AuthContext';
import { getAdminLoginPath, getAdminPostsPath, getAdminMediaListPath, getAdminCategoriesPath, getAdminTagsPath } from '../../shared/config/env';
import './AdminSidebar.css';

/**
 * 管理画面のサイドメニューコンポーネント
 */
const AdminSidebar: FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const adminLoginPath = getAdminLoginPath();
  const adminPostsPath = getAdminPostsPath();
  const adminMediaListPath = getAdminMediaListPath();
  const adminCategoriesPath = getAdminCategoriesPath();
  const adminTagsPath = getAdminTagsPath();

  const handleLogout = () => {
    const confirmed = window.confirm('ログアウトしますか？');
    if (confirmed) {
      logout();
      navigate(adminLoginPath, { replace: true });
    }
  };

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar__header">
        <h2 className="admin-sidebar__title">管理画面</h2>
      </div>
      <nav className="admin-sidebar__nav">
        <ul className="admin-sidebar__menu">
          <li className="admin-sidebar__menu-item">
            <Link
              to={adminPostsPath}
              className={`admin-sidebar__link ${
                location.pathname === adminPostsPath ? 'active' : ''
              }`}
            >
              記事一覧
            </Link>
          </li>
          <li className="admin-sidebar__menu-item">
            <Link
              to={adminMediaListPath}
              className={`admin-sidebar__link ${
                location.pathname === adminMediaListPath ? 'active' : ''
              }`}
            >
              メディア一覧
            </Link>
          </li>
          <li className="admin-sidebar__menu-item">
            <Link
              to={adminCategoriesPath}
              className={`admin-sidebar__link ${
                location.pathname.startsWith(adminCategoriesPath) ? 'active' : ''
              }`}
            >
              カテゴリー管理
            </Link>
          </li>
          <li className="admin-sidebar__menu-item">
            <Link
              to={adminTagsPath}
              className={`admin-sidebar__link ${
                location.pathname.startsWith(adminTagsPath) ? 'active' : ''
              }`}
            >
              タグ管理
            </Link>
          </li>
          <li className="admin-sidebar__menu-item">
            <Link
              to="/admin/posts/html-regenerate"
              className={`admin-sidebar__link ${
                location.pathname === '/admin/posts/html-regenerate' ? 'active' : ''
              }`}
            >
              メンテナンス
            </Link>
          </li>
        </ul>
      </nav>
      <div className="admin-sidebar__footer">
        <button
          className="admin-sidebar__logout-button"
          onClick={handleLogout}
        >
          ログアウト
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;

